<template>
    <ob1-message-alerte
        :title="title"
        :link-href="linkHref"
        :link-label="linkLabel"
        type="info"
        :with-arrow-link="true"
        :is-simple-alerte="false"
    />
</template>

<script>
export default {
    name: "IncentiveAuthenticate",
    props: {
        title: {
            type: String,
            required: true
        },
        text: {
            type: String,
            required: true
        },
        linkHref: {
            type: String,
            required: true
        },
        linkLabel: {
            type: String,
            required: true
        }
    }
}
</script>
